import { combineEpics } from 'redux-observable'

import brandConfig from 'brandConfig'

const features = brandConfig.features
const resolveEpicImports = () =>
  Promise.all([
    import('./auth'),
    import('./main'),
    import('./account'),
    import('./transactions'),
    import('./rewards'),
    import('./points'),
    import('./redeem'),
    import('./exchange'),
    import('./nft'),
    import('./cashback'),
    import('./wallet'),
    import('./quest'),
    import('./game'),
    import('./earnVia'),
    import('./referral'),
    features.homeBanners ? import('./banners') : null,
    features.staking ? import('./staking') : null,
    features.rewardBoxes ? import('./rewardBox') : null
  ])

const getRootEpic = async () => {
  const epics = await resolveEpicImports()

  const extractedEpics = epics
    .filter((f) => f)
    .map((c) => c[Object.getOwnPropertyNames(c)[1]])

  return combineEpics(...extractedEpics)
}

export { getRootEpic }
